export const PROJECT = 'project';
export const PROJECT_TITLE = 'projectTitle';

export type ContainerType = typeof PROJECT;
